import {
  CartLocation,
  EMPTY_ADD_TO_CART_METADATA,
  STOREFRONT_CART_ATTRIBUTES,
} from "@root/tablescape/constants";
import {
  getMsrpForVariant,
  getShopifyGlobalId,
  getTolstoyVariantMetadata,
} from "@root/tablescape/utilities";
import {
  TablescapeContext,
  TablescapeEvent,
} from "@root/tablescape/utilities/tablescapeContext";
import { component } from "picoapp";
import {
  type LanguageCode,
  type CountryCode,
} from "@shopify/hydrogen-react/storefront-api-types";

export const tolstoyHomepageCarousel = component(() => {
  const connectArrowButtons = () => {
    const prevBtn = document.querySelector(".tolstoy-previous-btn");
    const nextBtn = document.querySelector(".tolstoy-next-btn");

    prevBtn?.addEventListener("click", () => {
      document
        .querySelector<HTMLButtonElement>(".tolstoy-previous-button")
        ?.click();
    });
    nextBtn?.addEventListener("click", () => {
      document
        .querySelector<HTMLButtonElement>(".tolstoy-next-button")
        ?.click();
    });
  };

  const updateCarouselStyling = () => {
    const title = document.querySelector(".carousel-title");
    const leftPosition = title?.getBoundingClientRect().left;
    const carousel = document.querySelector<HTMLDivElement>(
      ".tolstoy-carousel-videos-container"
    );
    if (carousel) carousel.style.paddingLeft = `${leftPosition}px`;
  };

  const subscribeToTolstoyAddToCartClick = () => {
    const addTolstoyItemToCart = async (data: {
      quantity: number;
      variantId: string;
    }) => {
      const abortController = new AbortController();

      const productVariant = await getTolstoyVariantMetadata(
        {
          id: getShopifyGlobalId("ProductVariant", data.variantId),
          country: document.documentElement.dataset?.countryCode as CountryCode,
          language: document.documentElement.dataset
            ?.languageCode as LanguageCode,
        },
        { abortController }
      );

      const lines = [
        {
          attributes: [
            {
              key: STOREFRONT_CART_ATTRIBUTES.MSRP,
              value: getMsrpForVariant(productVariant),
            },
            ...(productVariant.shippingNote
              ? [
                  {
                    key: STOREFRONT_CART_ATTRIBUTES.PREORDER,
                    value: String(true),
                  },
                ]
              : []),
          ],
          id: getShopifyGlobalId("ProductVariant", data.variantId),
          quantity: data.quantity,
        },
      ];

      try {
        requestAnimationFrame(() => {
          TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
            ui: {
              cartDrawerOpen: true,
              cartDrawerUserToggled: false,
              giftNoteDrawerOpen: false,
              productVariantDrawerOpen: false,
            },
          });
          TablescapeContext.emit(TablescapeEvent.ADD_TO_CART, {
            cart: {
              lines,
              metadata: {
                ...EMPTY_ADD_TO_CART_METADATA,
                location: CartLocation.TOLSTOY_CAROUSEL,
              },
            },
          });
          window.tolstoyWidget.closePlayer();
          window.tolstoyWidget.postMessage({
            eventName: "tolstoy_add_to_cart_success",
          });
        });
      } catch (e) {
        console.error(e);
        window.tolstoyWidget.postMessage({
          eventName: "tolstoy_add_to_cart_error",
        });
      }
    };

    window.tolstoyWidget.subscribe(
      "tolstoy_add_to_cart",
      addTolstoyItemToCart,
      {}
    );
  };

  const onTolstoyWidgetReady = () => {
    connectArrowButtons();
    updateCarouselStyling();
    subscribeToTolstoyAddToCartClick();
  };

  window.addEventListener("tolstoyWidgetReady", onTolstoyWidgetReady);
});
